import { useEffect } from 'react';

const useStickyCard = (isMobile, compareItemWidth) => {
	const marginStickyValue = 10;

	useEffect(() => {
		const stickyCardContainer = document?.querySelector(
			'.ws-vehicle-compare .sticky-card-container'
		);
		const compareButton = document?.querySelector(
			'.ws-vehicle-compare .compare-done-button'
		);
		const scrollContainer = document.querySelector(
			'.ws-vehicle-compare .compare-item-list'
		);

		if (compareButton) {
			compareButton.style.marginTop = `-${stickyCardContainer?.offsetHeight}px`;
		}

		const adjustOverflowMobile = () => {
			if (isMobile) {
				const ddcDocument = document?.querySelector('.ddc-document');

				if (ddcDocument) {
					const ddcPage = ddcDocument?.querySelector('.ddc-page');

					const { marginTop, paddingTop } = ddcPage.style;

					// Only adjust the first time
					if (!paddingTop) {
						ddcDocument.style.overflow = 'visible';
						ddcPage.style.marginTop = '';
						ddcPage.style.paddingTop = marginTop;
					}
				}
			}
		};

		const scrollWithSticky = () => {
			let stickyPosition = 0;
			const imgVehicleContainer = document?.querySelector(
				'.ws-vehicle-compare .img-container'
			);
			const pageHeader = document?.querySelector('.page-header');
			if (stickyCardContainer && imgVehicleContainer) {
				const pageHeaderHeight = pageHeader?.offsetHeight || 0;
				const navbarHeight =
					document?.querySelector('.navbar')?.offsetHeight || 0;
				const clientReactBottom =
					imgVehicleContainer.getBoundingClientRect().bottom;

				if (pageHeader?.classList.contains('shrink-header-nav')) {
					// Collapse Header on Desktop
					stickyPosition = pageHeaderHeight + navbarHeight;
				} else {
					// Collapse Header on Mobile
					stickyPosition =
						pageHeaderHeight > 0 ? pageHeaderHeight : navbarHeight;
				}

				// Check if the scroll container has horizontal overflow
				const isOverflow =
					scrollContainer &&
					scrollContainer.scrollWidth > scrollContainer.clientWidth;
				// Set padding on sticky card container to align with the compare button when overflowing
				if (isOverflow) {
					const stickyCard =
						stickyCardContainer.querySelector('.border');

					if (imgVehicleContainer && stickyCard) {
						const imgVehicleRect =
							imgVehicleContainer.getBoundingClientRect();
						const stickyContainerRect =
							stickyCardContainer.getBoundingClientRect();
						const stickyCardWidth =
							stickyCard.getBoundingClientRect().width;
						// Account for horizontal scroll: convert viewport coords back to container coords
						const buttonScrollAdjustedLeft =
							imgVehicleRect.left + scrollContainer.scrollLeft;
						const offset =
							buttonScrollAdjustedLeft -
							(stickyCardWidth - imgVehicleRect.width) / 2 -
							stickyContainerRect.left;
						stickyCardContainer.style.paddingLeft = `${
							offset > 0 ? offset : 0
						}px`;
						stickyCardContainer.style.paddingRight = `${
							offset > 0 ? offset : 0
						}px`;
					}
				}

				// Set position for sticky card
				stickyCardContainer.style.top = `${
					stickyPosition + marginStickyValue
				}px`;
				if (clientReactBottom - stickyPosition <= 0) {
					stickyCardContainer.classList.add('show');

					adjustOverflowMobile();
				} else {
					stickyCardContainer.classList.remove('show');
				}
			}
		};

		// Hoist throttled reference to ensure cleanup matches registration
		const throttledScroll = window?._?.throttle(scrollWithSticky, 400);

		window?.addEventListener('scroll', throttledScroll);
		window.addEventListener('resize', throttledScroll);
		if (scrollContainer) {
			scrollContainer.addEventListener('scroll', throttledScroll);
		}

		return () => {
			window?.removeEventListener('scroll', throttledScroll);
			window.removeEventListener('resize', throttledScroll);
			if (scrollContainer) {
				scrollContainer.removeEventListener('scroll', throttledScroll);
			}
		};
	}, [isMobile, compareItemWidth]);
};

export default useStickyCard;
